import React, { PropTypes } from "react";
import FormattedHeightLimit from "./FormattedHeightLimit";
import FormattedWeightLimit from "./FormattedWeightLimit";

const DefaultDescription = ({ size }) => {
  return (
    <table className="car-seat-description">
      <tbody>
        <tr>
          <th>Height:&nbsp;</th>
          <td><FormattedHeightLimit size={size} /></td>
        </tr>
        <tr><td>&nbsp;</td></tr>
        <tr>
          <th>Weight:&nbsp;</th>
          <td><FormattedWeightLimit size={size} /></td>
        </tr>
      </tbody>
    </table>
  );
};

DefaultDescription.propTypes = {
  size: PropTypes.object.isRequired,
};

export default DefaultDescription;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Descriptions/DefaultDescription.js
 **/